// Axios do dashboard com auth DeviseTokenAuth.
// Reaplica headers a cada request — no embed o cookie pode ficar disponível após o boot.
import Auth from '../api/auth';

const parseErrorCode = error => Promise.reject(error);

const applyAuthHeaders = config => {
  if (!Auth.hasAuthCookie()) return config;
  const {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  } = Auth.getAuthData();
  Object.assign(config.headers, {
    'access-token': accessToken,
    'token-type': tokenType,
    client,
    expiry,
    uid,
  });
  return config;
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({
    baseURL: `${apiHost}/`,
    withCredentials: true,
  });

  wootApi.interceptors.request.use(applyAuthHeaders);
  wootApi.interceptors.response.use(
    response => response,
    error => parseErrorCode(error)
  );
  return wootApi;
};
